declare const GLightbox

/**
 * Hooks up all sliders into the HTML template
 */
export const engageAllInlineGallerySliders = (): void => {
  const allSliders = document.querySelectorAll('.js-galleryInlineSlider') as unknown as HTMLElement[]

  /**
   * Manages the custom class handling for the slider as this is impossible to do via raw CSS
   * @param list List of all trigger elements (image wrappers)
   */
  const appendCustomClasses = (list: HTMLElement[]) => {
    const activeItemsList = [...list.filter(item => item.classList.contains('tns-slide-active'))]
    activeItemsList.forEach(item => {
      item.classList.remove('sliderFirstActive')
      item.classList.remove('sliderSecondActive')
      item.classList.remove('sliderThirdActive')
    })
    activeItemsList[0].classList.add('sliderFirstActive')
    activeItemsList[1].classList.add('sliderSecondActive')
    activeItemsList[2].classList.add('sliderThirdActive')
  }

  /**
   * Hooks up TNS to the wrapper element
   * @param singleSlider The wrapper element for the TNS to hook up
   */
  const engageSlider = (singleSlider: HTMLElement) => {
    const slider = tns({
      container: singleSlider,
      controlsContainer: singleSlider,
      mouseDrag: true,
      swipeAngle: false,
      items: 3,
      slideBy: 3,
      autoplay: false,
      nav: false,
      autoplayButtonOutput: false,
      loop: false,
      controls: false,

      responsive: {
        768: {
          slideBy: 1,
          mouseDrag: false
        }
      }
    })

    const galleryTriggers = singleSlider.querySelectorAll('.js-inlineGalleryPopupTrigger') as unknown as HTMLLinkElement[]
    const galleryTriggersList = [...galleryTriggers]
    const galleryItems = [] as {
      href: string
      type: string
    }[]

    appendCustomClasses(galleryTriggersList)

    galleryTriggers.forEach(trigger => {
      const newItem = {
        href: trigger.dataset.href as string,
        type: 'image'
      }
      galleryItems.push(newItem)

      // Add a trigger to each miniature to load the gallery
      trigger.addEventListener('click', (e) => {
        e.preventDefault()

        const windowWidth = window.innerWidth

        const generalIndex = galleryTriggersList.findIndex(single => {
          return (single.dataset.id === trigger.dataset.id)
        })

        const activeItemsList = [...galleryTriggersList.filter(item => item.classList.contains('tns-slide-active'))]
        const activeIndex = activeItemsList.findIndex(single => {
          return (single.dataset.id === trigger.dataset.id)
        })

        if (activeIndex === 0 && windowWidth > 768) {
          moveSlider('left', galleryTriggersList)
        }
        if (activeIndex === 1 || generalIndex === 0 || generalIndex === galleryTriggersList.length - 1 || windowWidth <= 768) {
          openGallery(trigger)
        }

        if (activeIndex === 2 && windowWidth > 768) {
          moveSlider('right', galleryTriggersList)
        }
      })
    })

    /**
     * Moves the slider left or right
     * @param position Determines if the movement should be right or left
     * @param galleryTriggersList List of all trigger wrappers
     */
    const moveSlider = (position: 'left'|'right', galleryTriggersList: HTMLElement[]) => {
      if (position === 'left' && slider) {
        slider.goTo('prev')
        appendCustomClasses(galleryTriggersList)
      }
      if (position === 'right' && slider) {
        slider.goTo('next')
        appendCustomClasses(galleryTriggersList)
      }
    }

    /**
     * Opens the actual gallery on the right index based on the image clicked
     * @param trigger The current HTML trigger
     */
    const openGallery = (trigger: HTMLElement) => {
      // Determine what index we open the gallery on
      const index = galleryTriggersList.findIndex(single => {
        return (single.dataset.href === trigger.dataset.href)
      })
      myGallery.settings.startAt = index

      // Open the gallery
      myGallery.open()
    }

    // Load the actual gallery
    const myGallery = GLightbox({
      elements: galleryItems
    })
  }

  allSliders.forEach(slider => {
    engageSlider(slider)
  })
}
